module.exports = __webpack_public_path__ + "static/img/icon19.d8d88251.png";